import { render, staticRenderFns } from "./SKUEdit.vue?vue&type=template&id=1e5705cc&scoped=true"
import script from "./SKUEdit.vue?vue&type=script&lang=js"
export * from "./SKUEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5705cc",
  null
  
)

export default component.exports